import React, { useState } from "react";
import { useTeamContext } from "store/contexts/teamContext";
import TeamService from "services/TeamService";
import { useGlobalContext } from "store/contexts/globalContext";
import { useHistory } from "react-router-dom";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";
import { ReactComponent as DeleteIcon } from "assets/img/icons/Delete.svg";
import Loader from "components/Loader";

var styles = {
  titleDailog: {
    padding: "24px 24px 10px",
    fontSize: "1.25rem",
    fontWeight: "900",
    marginBottom: "0",
  },
  headingDailog: {
    fontSize: "1rem",
    padding: "0px 24px",
    marginBottom: "12px",
  },
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    padding: "10px 8px",
  },
};

export default () => {
  const classes = styles;
  const { team } = useTeamContext();
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [confimDeleteTeam, setConfirmDeleteTeam] = useState(false);
  const { deleteTeam } = useGlobalContext();

  const handleDeleteClicked = async () => {
    setConfirmDeleteTeam(true);
  };

  const deleteMyTeam = async () => {
    try {
      setLoading(true);
      await TeamService.deleteMyTeam(team.id);

      setLoading(false);
      deleteTeam(team);

      history.push("/");
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div onClick={() => handleDeleteClicked()} style={{ cursor: "pointer" }}>
        <DeleteIcon className="mx-2" />
        <span>Delete The Team</span>
      </div>
      <Modal
        open={confimDeleteTeam}
        onClose={() => setConfirmDeleteTeam(false)}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "rootModalContainer",
        }}
      >
        <h2 style={classes.titleDailog}>Delete Team Confirmation</h2>
        <h6 style={classes.headingDailog}>
          Do you want to delete this team, kindly confirm.
        </h6>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setConfirmDeleteTeam(false);
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading && true}
            onClick={deleteMyTeam}
            buttonClass=" small-reject-btn "
          >
            {!loading ? "Confirm" : <Loader width={20} height={20} />}
          </Button>
        </div>
      </Modal>
    </>
  );
};
